// extracted by mini-css-extract-plugin
export default {"ReplyButton":"pf_a bhc_vr bhc_iv bhc_wf bhc_i bhc_j bhc_q bhc_un bhc_en bhc_ri bhc_rj bhc_cx","ReplyButton__icon":"pf_b bhc_re"};